import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { CorrespondenceCompanyDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-correspondencecompany-container',
  templateUrl: './correspondencecompany-container.component.html',
  styleUrls: ['./correspondencecompany-container.component.scss']
})
export class CorrespondencecompanyContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  correspondenceCompanys$: Observable<CorrespondenceCompanyDto[]>;
  loading: boolean;
  isLoadingCorrespondenceCompany$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingCorrespondenceCompany$ = this.gatwayFacade.isLoadingGateway("CorrespondenceCompany");
    this.correspondenceCompanys$ = this.gatwayFacade.loadGateway("CorrespondenceCompany");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCorrespondenceCompany(deletedValue: any) {
    this.gatwayFacade.remove("CorrespondenceCompany", deletedValue);
  }


// this method control both the create and update

  onSubmitCorrespondenceCompany(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.CorrespondenceCompanys;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllCorrespondenceCompany = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllCorrespondenceCompany.push(pullData[i]);
    }
  }

// check if the addAllBank array is not empty, then dispatch the data to the store
   if(addAllCorrespondenceCompany.length > 0) {
    this.gatwayFacade.add('CorrespondenceCompany', addAllCorrespondenceCompany);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('CorrespondenceCompany', allUpdates, ['id']);
  }

   }

}
